$(document).on('click', '.textmedia__more-link a', function(event) {
	event.preventDefault();

	var $link = $(this);
	var readMore = $link.data('read-more');
	var readLess = $link.data('read-less');
	if (!readMore) {
		readMore = $link.text();
		$link.data('read-more', readMore);
	}

	var $moreText = $link.closest('.textmedia__more-link').prev('.textmedia__more');
	var $svg = $link.children('.svg');
	if ($moreText.hasClass('textmedia__more--hidden')) {
		$link.text(readLess);
		$link.prepend($svg);

		$moreText.height($moreText.prop('scrollHeight'));
		$moreText.removeClass('textmedia__more--hidden');
	} else {
		$link.text(readMore);
		$link.prepend($svg);
		$link.height();
		$moreText.addClass('textmedia__more--hidden');
	}
});
